import style from "../style/components/Legal.module.css";
export default () => {
    return (
        <div className={style["container"]}>
            <h1>하이비츠 개인정보처리방침</h1>
            <p>본 개인정보처리방침은 대한민국 법률에 따라 작성되었습니다.</p>
            <h1>제1조(개요)</h1>
            <p>
                “하이비츠 애플리케이션”(앱)(이하 "서비스")은 (주)하이비츠(이하
                "회사")가 관련하여 제공하는 프로그램, 소프트웨어, 웹사이트, 제품
                등을 말합니다. 회사는 서비스의 이용조건에 동의하고, 서비스
                이용을 신청하며, 회사가 서비스를 이용할 수 있는 권리를 가진
                고객(이하 "이용자")의 동의에 따라 개인정보를 처리하고 있으며,
                개인정보보호법 제30조에 따라 이용자의 개인정보를 보호하기 위하여
                다음과 같은 기본원칙을 정하고 이를 준수하고 있습니다. 이와
                관련한 모든 불만사항을 신속하고 원활하게 처리합니다.
            </p>
            <ol>
                <li>
                    회사는 이용자의 개인정보를 처리하기 위하여 적절한 방법으로
                    이용자에게 통지하고 동의를 구합니다.
                </li>
                <li>
                    회사는 서비스 제공을 위해 필요한 최소한의 범위 내에서
                    이용자의 개인정보를 처리합니다.
                </li>
                <li>
                    회사는 서비스를 위한 개인정보의 처리 목적이 달성되기 위해
                    필요한 최소한의 정보만을 수집하고 있습니다.
                </li>
                <li>
                    회사는 이용자로부터 수집한 개인정보를 이용자의 동의가 있거나
                    관련 법령에서 정한 경우를 제외하고는 서비스 처리 목적 외로
                    이용하지 않으며, 이용자의 동의가 있거나 관련 법령을 준수하기
                    위하여 필요한 최소한의 기간 동안 보관합니다.
                </li>
                <li>
                    회사는 이용자의 개인정보를 정확하고 완전하며 최신의 상태로
                    유지하기 위해 노력합니다.
                </li>
                <li>
                    회사는 이용자의 개인정보를 보호하기 위해 적절한
                    기술적/관리적 보호 대책을 강구합니다.
                </li>
                <li>
                    당사는 이용자의 개인정보 처리에 관한 정책 및 절차를 투명하고
                    합리적으로 수립합니다.
                </li>
                <li>
                    이용자는 관련 법령이 정한 바에 따라 이용자 스스로 자신의
                    개인정보에 접근할 수 있으며, 이용자는 언제든지 자신의
                    개인정보를 수정할 수 있습니다.
                </li>
                <li>
                    회사는 이용자가 수집하는 개인정보를 관리할 책임이 있습니다.
                    회사는 이러한 원칙, 본 개인정보처리방침 및 관련 법령에 대한
                    이용자의 의견을 경청하고 있습니다.
                </li>
            </ol>

            <h1>제2조(개인정보처리방침의 적용 목적 및 범위)</h1>
            <p>
                이 개인 정보 보호 정책은 당사가 귀하의 개인 정보를 처리하고
                보호하는 방법, 귀하의 개인 정보에 대한 귀하의 권리 및 선택권을
                설명합니다. 본 개인 정보 보호 정책은 귀하가 서비스를 사용할 때
                당사가 수집하는 개인 정보, 귀하가 서비스에 액세스할 때 당사에
                제공하는 정보 및 다른 사용자가 공개한 귀하의 개인 정보에
                적용됩니다.
            </p>

            <h1>제3조(개인정보의 수집 및 이용목적)</h1>
            <p>
                회사는 회원관리, 서비스 제공 및 개선, 신규 서비스 개발 등을 위해
                개인정보를 처리합니다. 회사는 본 서비스에 가입하거나 서비스를
                이용하는 과정에서 애플리케이션 또는 프로그램을 통해 본 서비스
                제공에 필요한 최소한의 개인정보를 아래와 같이 처리합니다. 이
                개인 정보 보호 정책은 당사가 귀하의 개인 정보를 처리하고
                보호하는 방법, 귀하의 개인 정보에 대한 귀하의 권리 및 선택권을
                설명합니다. 본 개인 정보 보호 정책은 귀하가 서비스를 사용할 때
                수집하는 개인 정보, 서비스에 액세스할 때 당사에 제공하는 정보 및
                다른 사용자가 공개한 귀하의 개인 정보에 적용됩니다.
            </p>
            <ol>
                <li>이용자 본인확인/가입의사 확인, 연령확인, 부정 이용 방지</li>
                <li>
                    이용자에게 활동 이력을 알리거나 이용자 검색, 등록 등의 기능
                    제공
                </li>
                <li>
                    새로운 서비스의 개발, 각종 서비스의 제공, 문의사항 또는
                    불만의 처리, 고지사항 전달
                </li>
                <li>
                    유료 서비스 이용, 콘텐츠 등의 이전 및 요금의 정산에 관한
                    사항
                </li>
                <li>
                    서비스의 원활한 운영을 방해하는 행위(계정 도용, 부정 이용 등
                    포함)에 대한 예방 및 제재
                </li>
                <li>
                    인구통계학적 특성과 사용자의 관심, 선호도, 경향성 추정을
                    통한 맞춤형 콘텐츠 추천 및 마케팅
                </li>
                <li>
                    서비스 이용 기록, 서비스 이용에 대한 접속 빈도 및 통계,
                    개인정보 보호에 관한 서비스 환경 구축, 서비스 개선을 위한
                    이용
                </li>
                <li>
                    마케팅 전략을 수립하기 위해 Google Analytics를 이용할 때
                    필요한 정보
                </li>
            </ol>

            <h1>제4조(수집하는 개인정보 항목)</h1>
            <ol>
                <li>
                    귀하가 당사에 제공하는 개인 정보
                    <br />
                    회사는 이용자에게 앱 서비스를 제공하기 위해 다음의 정보일부
                    또는 전부를 수집/처리합니다.
                    <ol>
                        <li>
                            프로필 정보: <br />
                            전화번호, 비밀번호, 성별, 생년월일
                        </li>
                        <li>
                            위치정보의 이용: <br />
                            회사는 아래의 기능 제공을 위해 위치기반 서비스를
                            이용하나, 회원의 위치 정보 수집은 지도 서비스
                            제공만을 위해 사용합니다.
                        </li>
                        <li>하이비츠 앱의 하이비츠 즐겨찾기</li>
                        <li>하이비츠 앱의 가까운 하이비츠 찾기</li>
                        <li>
                            유료 서비스 이용 및 결제에 관한 정보
                            <ol>
                                <li>
                                    신용카드 결제의 경우: 카드번호(일부),
                                    카드명, 카드유효기간 등
                                </li>
                                <li>
                                    휴대폰 번호로 결제하는 경우: 휴대폰 번호,
                                    결제 승인 번호 등
                                </li>
                                <li>상품권 사용 시: 상품권 번호, 닉네임 등</li>
                                <li>
                                    기타 결제: PG(Payment Gateway) 대행
                                    시스템에서 요구하는 정보
                                </li>
                                <li>
                                    환불 처리에 관한 정보: 은행명, 계좌번호,
                                    예금주명, 이메일 등
                                </li>
                                <li>
                                    이용자가 직접 보내는 정보: 이용자가 서비스
                                    이용 중 당사에 보낸 모든 정보(문의 등)
                                </li>
                                <li>
                                    설문조사 및 이벤트 정보: 이용자가 설문조사에
                                    참여하여 기록한 정보, 이벤트 또는 추첨에
                                    참여할 때 전송되는 개인정보(성별, 연령, 선호
                                    성향, 주소 등 포함)
                                </li>
                            </ol>
                        </li>
                    </ol>
                </li>
                <li>
                    당사가 자동으로 수집하는 정보
                    <br />
                    이용자가 회사의 서비스를 이용할 때 회사는 일부 정보를
                    자동으로 수집합니다. 회사는 서비스를 통한 이용자의 이용 및
                    활동에 관한 정보를 수집할 수 있습니다. 귀하가 당사 서비스를
                    사용할 때 당사는 귀하의 운영 체제, 쿠키, 인터넷 프로토콜(IP)
                    주소, 액세스 시간, 브라우저 유형 및 언어, 당사 서비스를
                    사용하기 전에 방문한 웹사이트와 같은 정보를 자동으로 기록할
                    수 있습니다. 당사가 자동으로 수집하는 정보는 다음과
                    같습니다.
                    <ol>
                        <li>
                            장치 정보: <br />
                            회사는 장치별 정보(하드웨어 모델, 운영 체제 버전,
                            장치 고유 식별자 및 모바일 네트워크 정보)를
                            수집합니다. 회사는 사용자의 장치 식별자를 사용자의
                            앱 계정과 연결할 수 있습니다.
                        </li>
                        <li>
                            로그 정보: <br />
                            이용자가 서비스를 이용할 때 회사는 자동으로 특정
                            정보를 수집하여 서버에 저장합니다. 당사가 수집하는
                            정보는 다음과 같습니다.
                            <br />
                            장치 또는 앱 계정을 고유하게 식별하는 인터넷
                            프로토콜(IP) 주소, 충돌, 시스템 활동, 하드웨어 설정,
                            브라우저 유형, 언어, 앱 서비스 사용 날짜 및 시간,
                            당사 웹사이트, 모바일 앱 및/또는 컴퓨터 소프트웨어
                            방문 기록과 같은 장치 이벤트 정보.
                        </li>
                    </ol>
                </li>
            </ol>

            <h1>제5조(개인정보의 제3자 제공)</h1>
            <p>
                회사는 이용자의 별도 동의가 있거나 법령에 규정된 경우를
                제외하고는 이용자의 개인정보를 제3자에게 제공하지 않습니다.
                회사는 이용자의 개인정보를 제공하거나 공유하는 경우 사전에
                이용자에게 제공되거나 공유되는 주체, 개인정보의 주된 업무가
                무엇인지, 개인정보를 제공 또는 공유하는 목적을 고지하고,
                개인정보 수집에 대한 동의 절차에 따라 이용자가 동의 또는 거부할
                수 있도록 조치합니다. 또는 이메일 또는 서면으로 사용자에게
                개별적으로 통지하고 동의를 구합니다. 다만, 다음의 경우에는 관련
                법령의 규정에 의하여 이용자의 동의 없이 개인정보를 제공할 수
                있습니다.
            </p>
            <ol>
                <li>
                    사업주가 법령에 의거하여 동의한 경우 또는 수사 목적으로
                    법령이 정하는 절차와 방법에 따라 수사기관의 요구가 있는 경우
                </li>
                <li>
                    임직원 또는 법정대리인이 의사표시를 할 수 없는 상태이거나
                    주소불명 등으로 인해 사전 동의를 구할 수 없는 상태로서
                    정보주체 또는 제3자의 생명 또는 안전에 급박한 위험이 있음을
                    명백히 인정하여 이를 제거하고자 합니다.
                </li>
                <li>
                    정보통신서비스 제공에 관한 요금정산을 위하여 필요한 경우
                </li>
                <li>다른 법률에 특별한 규정이 있는 경우</li>
            </ol>

            <h1>제6조(개인정보의 보유기간 및 파기)</h1>
            <p>
                개인정보는 원칙적으로 수집 및 이용목적이 달성되면 지체 없이
                파기하며, 절차 및 방법은 다음과 같습니다. 전자적 파일의 경우
                복구 또는 재생할 수 없도록 안전하게 삭제하며, 기록물, 인쇄물,
                서류 등의 경우 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.
                다만, 관련 법령 및 내부 방침에 따라 일정 기간 보관 후 파기되는
                정보는 다음과 같습니다.
            </p>
            <ol>
                <li>
                    다음 각 호의 정보는 탈퇴일로부터 최대 1년간 보관 후
                    파기됩니다.
                    <ul>
                        <li>
                            안내 이메일 발송 및 CS 문의 답변을 위한 암호화된
                            계정 및 출금 안내 이메일 주소
                        </li>
                        <li>서비스 부정 이용 기록</li>
                        <li>
                            서비스 혜택의 중복 제공을 방지하기 위해 필요한 기록
                        </li>
                    </ul>
                </li>
                <li>
                    개인정보의 처리 및 보유 기간은 다음과 같습니다.
                    <ul>
                        <li>
                            회원가입정보 : 회사는 1년간 서비스를 이용하지 않은
                            이용자의 개인정보를 '개인정보 유효기간'에 따라
                            별도로 보관하거나 삭제하며, 별도로 저장된 개인정보는
                            4년간 보관 후 지체 없이 파기합니다.
                        </li>
                    </ul>
                </li>
                <li>
                    이용자가 서비스를 탈퇴하는 경우에도 회사는 다음과 같이
                    합리적으로 필요한 경우 이용자의 개인정보를 보관할 수
                    있습니다.
                    <ul>
                        <li>관련 법률, 규정 또는 법적 의무를 준수하기 위해</li>
                        <li>
                            당사가 제공하던 고객 지원 서비스를 완료하기 위해
                        </li>
                        <li>이용자 간의 분쟁 조정 등을 위해</li>
                        <li>서비스의 부정 이용 또는 남용을 방지하기 위해</li>
                    </ul>
                </li>
                <li>
                    또한 법령 및 관련 법령에 따라 일정기간 동안 보관해야 하는
                    개인정보는 다음과 같습니다.
                    <ul>
                        <li>
                            계약 또는 청약철회 등에 관한 기록 : 5년 (전자상거래
                            등에서의 소비자보호에 관한 법률)
                        </li>
                        <li>
                            대금결제 및 재화 등의 공급에 관한 기록 : 5년
                            (전자상거래 등에서의 소비자보호에 관한 법률)
                        </li>
                        <li>
                            소비자의 불만 또는 분쟁처리에 관한 기록 : 3년
                            (전자상거래 등에서의 소비자보호에 관한 법률)
                        </li>
                        <li>
                            신용정보의 수집/처리 및 이용 등에 관한 기록 : 3년
                            (신용정보의 이용 및 보호에 관한 법률)
                        </li>
                        <li>
                            표시/광고에 관한 기록 : 6개월 (전자상거래 등에서의
                            소비자보호에 관한 법률)
                        </li>
                        <li>접속기록 : 3개월 (통신비밀보호법)</li>
                    </ul>
                </li>
            </ol>

            <h1>제7조(개인정보의 기술적/관리적 보호 대책)</h1>
            <p>
                회사는 이용자의 소중한 개인정보를 가장 소중한 가치로 인식하고
                개인정보 취급에 있어 다음과 같은 노력을 기울이고 있습니다.
            </p>
            <ol>
                <li>
                    이용자의 개인정보 암호화 : 이용자의 개인정보는 암호화된
                    통신섹션을 이용하여 전송되며, 비밀번호 등 중요한 정보는
                    암호화되어 저장됩니다.
                </li>
                <li>
                    해킹 및 컴퓨터 바이러스로부터 보호: 해킹이나 컴퓨터 바이러스
                    등에 의해 이용자의 개인정보가 유출되거나 훼손되는 것을 막기
                    위하여 외부로부터 접근이 통제된 구역에 시스템을 설치하고
                    있습니다. 해커 등의 침입을 탐지 및 차단하고 24시간 감시할 수
                    있는 시스템을 설치하고 있으며, 시스템이 최신
                    악성소프트웨어나 바이러스에 감염되는 것을 방지하기 위해
                    안티바이러스 프로그램을 설치하고 있습니다.
                </li>
                <li>
                    개인정보에 대한 접근자의 최소화 및 유지·교육: 회사는
                    개인정보를 처리하는 직원을 최소화하고, 개인정보를 보관하는
                    데이터베이스시스템 및 개인정보를 처리하는 시스템에 대한
                    비밀번호를 부여하고 정기적으로 갱신하고 있으며, 해당 직원에
                    대한 수시 교육을 통하여 회사의 개인정보 관련 정책 및
                    개인정보처리방침의 준수를 항상 강조하고 있습니다.
                </li>
                <li>
                    회사는 개인정보처리방침의 이행사항 및 담당자의 준수여부를
                    개인정보보호책임자 등을 통하여 점검하고 있으며, 문제점이
                    발견될 경우 정정 및 정정할 수 있도록 노력하고 있습니다. 단,
                    이용자 본인의 부주의나 인터넷상의 문제로 ID, 비밀번호 등의
                    개인정보가 유출되어 발생한 문제에 대해서는 책임을 지지
                    않습니다.
                </li>
            </ol>

            <h1>제8조(아동에 관한 법률)</h1>
            <p>
                회사는 14세 미만의 아동을 보호하기 위해 노력합니다. 회사는 14세
                미만 아동의 개인 정보 보호를 위해 서비스 이용을 제한하기로
                결정했습니다. 본 서비스에 법정대리인 인증 절차가 기술적으로
                구축되기 전까지 만 14세 미만의 아동은 프로필을 생성할 수
                없습니다. 당사가 필요한 연령 미만의 아동에 대한 개인 정보를 보유
                또는 수집하는 것으로 의심되거나 질문이 있는 경우 신고 센터(
                <a href="mailto:support@hivits.co.kr">support@hivits.co.kr</a>
                )에 문의하십시오.
            </p>

            <h1>제9조(개인정보 보호책임자 )</h1>
            <ul>
                <li>성명 : 김진한</li>
                <li>직위 : 이사</li>
                <li>
                    연락처 :
                    <a href="mailto:support@hivits.co.kr">
                        support@hivits.co.kr
                    </a>
                </li>
            </ul>
            <p>
                귀하의 개인정보가 침해되어 신고나 상담이 필요한 경우에는 아래
                기관에 문의하여 도움을 받을 수 있습니다.
            </p>
            <ul>
                <li>
                    개인정보침해신고센터 (
                    <a href="https://privacy.kisa.or.kr" target="_blank">
                        https://privacy.kisa.or.kr
                    </a>
                    / 국번없이 118)
                </li>
                <li>
                    대검찰청 사이버수사과 (
                    <a href="mailto:cid@spo.go.kr">cid@spo.go.kr</a> / 국번없이
                    1301)
                </li>
                <li>
                    경찰청 사이버안전국 (
                    <a href="mailto:https://cyberbureau.police.go.kr">
                        https://cyberbureau.police.go.kr
                    </a>
                    / 국번없이 182)
                </li>
            </ul>

            <h1>제10조(개인정보처리방침의 변경 )</h1>
            <ol>
                <li>
                    이 개인정보처리방침은 시행일부터 적용되며, 회사는 법령 또는
                    서비스의 변경사항을 반영하기 위하여 개인정보처리방침을
                    변경할 수 있습니다. 개인정보처리방침이 변경되는 경우 회사는
                    변경사항을 게시하며, 변경된 개인정보처리방침은 게시한
                    날로부터 7일 후부터 효력이 발생합니다. 다만, 수집하는
                    개인정보의 항목이나 이용 목적의 변경 등 이용자 권리에 중대한
                    변경이 있을 경우에는 최소 30일 전에 공지하겠습니다.
                </li>
                <li>본 개인정보처리방침은 2025년 1월 01일부터 시행됩니다. </li>
            </ol>
        </div>
    );
};
